var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _rect, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureShadowAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 27,
    viewBox: "0 0 34 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33899 10.678H15.393V5L13.55 7.568L10.077 5L7.26799 7.568L4.33899 5V10.678Z",
    fill: "#6B696A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.005 16.6438C7.411 16.6438 5.302 14.5338 5.302 11.9408C5.302 9.34779 7.411 7.23779 10.005 7.23779C12.599 7.23779 14.708 9.34779 14.708 11.9408C14.708 14.5338 12.599 16.6438 10.005 16.6438ZM10.005 8.33979C8.02 8.33979 6.404 9.95579 6.404 11.9408C6.404 13.9258 8.02 15.5408 10.005 15.5408C11.99 15.5408 13.606 13.9258 13.606 11.9408C13.606 9.95579 11.99 8.33979 10.005 8.33979Z",
    fill: "#6B696A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.005 16.3938C7.54911 16.3938 5.552 14.3958 5.552 11.9408H5.052C5.052 14.6718 7.2729 16.8938 10.005 16.8938V16.3938ZM5.552 11.9408C5.552 9.48583 7.54911 7.48779 10.005 7.48779V6.98779C7.2729 6.98779 5.052 9.20976 5.052 11.9408H5.552ZM10.005 7.48779C12.4609 7.48779 14.458 9.48583 14.458 11.9408H14.958C14.958 9.20976 12.7371 6.98779 10.005 6.98779V7.48779ZM14.458 11.9408C14.458 14.3958 12.4609 16.3938 10.005 16.3938V16.8938C12.7371 16.8938 14.958 14.6718 14.958 11.9408H14.458ZM10.005 8.08979C7.88193 8.08979 6.154 9.81772 6.154 11.9408H6.654C6.654 10.0939 8.15807 8.58979 10.005 8.58979V8.08979ZM6.154 11.9408C6.154 14.064 7.88202 15.7908 10.005 15.7908V15.2908C8.15798 15.2908 6.654 13.7876 6.654 11.9408H6.154ZM10.005 15.7908C12.128 15.7908 13.856 14.064 13.856 11.9408H13.356C13.356 13.7876 11.852 15.2908 10.005 15.2908V15.7908ZM13.856 11.9408C13.856 9.81772 12.1281 8.08979 10.005 8.08979V8.58979C11.8519 8.58979 13.356 10.0939 13.356 11.9408H13.856Z",
    fill: "#6B696A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33899 10.678H15.393V5L13.55 7.568L10.077 5L7.26799 7.568L4.33899 5V10.678Z",
    stroke: "#6B696A",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.007 24.6513C18.967 21.0133 16.758 17.8883 13.614 16.5073C13.264 16.7973 12.877 17.0453 12.462 17.2443C15.589 18.2713 17.861 21.1963 17.904 24.6513H2.105C2.15 21.1963 4.421 18.2713 7.548 17.2443C7.133 17.0453 6.746 16.7973 6.395 16.5073C3.252 17.8883 1.043 21.0133 1.002 24.6513H1V25.7513H19.01V24.6513H19.007Z",
    fill: "#6B696A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.007 24.6513C18.967 21.0133 16.758 17.8883 13.614 16.5073C13.264 16.7973 12.877 17.0453 12.462 17.2443C15.589 18.2713 17.861 21.1963 17.904 24.6513H2.105C2.15 21.1963 4.421 18.2713 7.548 17.2443C7.133 17.0453 6.746 16.7973 6.395 16.5073C3.252 17.8883 1.043 21.0133 1.002 24.6513H1V25.7513H19.01V24.6513H19.007Z",
    stroke: "#6B696A",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7111 24.6508C23.6701 21.0818 21.5431 18.0058 18.4941 16.5868L18.2521 16.5218C18.0661 16.5158 17.5671 16.2958 16.9191 16.0668C18.3951 15.2718 19.4111 13.7308 19.4111 11.9408C19.4111 9.34779 17.3021 7.23779 14.7081 7.23779C12.1151 7.23779 10.0051 9.34779 10.0051 11.9408C10.0051 13.6298 10.9071 15.1018 12.2481 15.9308C11.9201 16.0778 11.5701 16.2678 11.0981 16.5068C7.95513 17.8888 5.74613 21.0128 5.70513 24.6508H5.70312V25.7508H23.7131V24.6508H23.7111Z",
    fill: "#368FEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7111 24.6508C23.6701 21.0818 21.5431 18.0058 18.4941 16.5868L18.2521 16.5218C18.0661 16.5158 17.5671 16.2958 16.9191 16.0668C18.3951 15.2718 19.4111 13.7308 19.4111 11.9408C19.4111 9.34779 17.3021 7.23779 14.7081 7.23779C12.1151 7.23779 10.0051 9.34779 10.0051 11.9408C10.0051 13.6298 10.9071 15.1018 12.2481 15.9308C11.9201 16.0778 11.5701 16.2678 11.0981 16.5068C7.95513 17.8888 5.74613 21.0128 5.70513 24.6508H5.70312V25.7508H23.7131V24.6508H23.7111Z",
    stroke: "#368FEF",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18176 10.678H20.2348V5L18.3928 7.568L14.9188 5L12.1108 7.568L9.18176 5V10.678Z",
    fill: "#368FEF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.18176 10.678H20.2348V5L18.3928 7.568L14.9188 5L12.1108 7.568L9.18176 5V10.678Z",
    stroke: "#368FEF",
    strokeWidth: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.75,
    y: 0.75,
    width: 18.5,
    height: 16.5,
    rx: 1.25,
    fill: "white",
    stroke: "#368FEF",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0005 3.00014H25.5514L21.8652 13.9219C21.8273 14.0342 21.7552 14.1317 21.659 14.2008C21.5627 14.2699 21.4473 14.307 21.3288 14.3071H18.5653C18.4756 14.3071 18.3871 14.2857 18.3073 14.2447C18.2274 14.2038 18.1585 14.1444 18.1061 14.0715C18.0538 13.9986 18.0195 13.9143 18.0062 13.8255C17.9929 13.7368 18.001 13.6461 18.0297 13.5611L21.464 3.38526C21.5018 3.27298 21.574 3.17541 21.6702 3.1063C21.7665 3.03719 21.882 3.00001 22.0005 3V3.00014Z",
    fill: "url(#paint0_linear_4362_1360)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1605 10.3257H21.5296C21.4772 10.3256 21.4261 10.3413 21.3828 10.3708C21.3395 10.4002 21.3061 10.442 21.2868 10.4907C21.2676 10.5394 21.2635 10.5927 21.2751 10.6438C21.2867 10.6949 21.3133 10.7413 21.3516 10.7769L24.9699 14.1541C25.0752 14.2524 25.2139 14.307 25.358 14.307H28.5464L27.1605 10.3257Z",
    fill: "#0078D4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0007 3C21.8809 2.99954 21.7641 3.0374 21.6674 3.10803C21.5707 3.17867 21.499 3.27839 21.463 3.39263L18.0341 13.5517C18.0035 13.637 17.9939 13.7285 18.0061 13.8183C18.0183 13.9082 18.052 13.9938 18.1043 14.0679C18.1565 14.1419 18.2259 14.2023 18.3065 14.244C18.387 14.2856 18.4764 14.3072 18.5671 14.3069H21.4019C21.5075 14.2881 21.6062 14.2415 21.6879 14.172C21.7696 14.1025 21.8314 14.0126 21.8669 13.9114L22.5507 11.8962L24.9932 14.1744C25.0955 14.259 25.2239 14.3058 25.3568 14.3069H28.5333L27.1401 10.3256L23.0788 10.3266L25.5644 3H22.0007Z",
    fill: "url(#paint1_linear_4362_1360)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5358 3.38458C26.498 3.27248 26.426 3.17508 26.3299 3.10608C26.2338 3.03709 26.1185 2.99999 26.0002 3H22.0427C22.161 3.00001 22.2763 3.03712 22.3724 3.10611C22.4685 3.1751 22.5406 3.27249 22.5784 3.38458L26.0128 13.5608C26.0416 13.6459 26.0496 13.7365 26.0363 13.8253C26.023 13.9141 25.9888 13.9984 25.9365 14.0714C25.8841 14.1443 25.8151 14.2037 25.7353 14.2447C25.6554 14.2857 25.5669 14.307 25.4772 14.3071H29.4347C29.5245 14.307 29.613 14.2856 29.6928 14.2446C29.7727 14.2036 29.8416 14.1442 29.8939 14.0713C29.9463 13.9984 29.9805 13.9141 29.9938 13.8253C30.007 13.7365 29.999 13.6459 29.9703 13.5608L26.5358 3.38458Z",
    fill: "url(#paint2_linear_4362_1360)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4362_1360",
    x1: 23.2947,
    y1: 3.83802,
    x2: 19.607,
    y2: 14.7324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4362_1360",
    x1: 24.4469,
    y1: 8.91496,
    x2: 23.5938,
    y2: 9.20339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4362_1360",
    x1: 23.9775,
    y1: 3.52013,
    x2: 28.0255,
    y2: 14.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureShadowAdmin);
export default __webpack_public_path__ + "static/media/azure_shadow_admin.151a384c5ed026da55ea4d3f77b1ab53.svg";
export { ForwardRef as ReactComponent };